import { render } from "./UserMenu.vue?vue&type=template&id=42f34a38&scoped=true"
import script from "./UserMenu.vue?vue&type=script&lang=js"
export * from "./UserMenu.vue?vue&type=script&lang=js"

import "./UserMenu.vue?vue&type=style&index=0&id=42f34a38&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42f34a38"]])

export default __exports__